import Icon from 'components/global/Icon';
import Typography from 'components/global/Typography';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons';

import * as S from './styled/Chart.styled';

const ChartTitle = ({ tooltip, children, subtitle }) => (
	<div>
		<S.ChartTitleStyled>
			<Typography variant="p2" fontWeight="500" noWrap>
				{children}
			</Typography>

			{tooltip && (
				<S.ChartTitleTootlipStyled placement="right" title={tooltip}>
					<Icon icon={faCircleInfo} />
				</S.ChartTitleTootlipStyled>
			)}
		</S.ChartTitleStyled>
		<Typography variant="p3" color="var(--content-3)" noWrap>
			{subtitle}
		</Typography>
	</div>
);

export default ChartTitle;
